"use strict";

var ActivitiesFilters = require("./activities-filters.jsx");
var ActivitiesListing = require("./activities-listing.jsx");
var ActivityInput = require("../ActivityInput/activity-input");
var agendorAPI = require("app/util/api/agendor-api");
var cx = require("classnames");
var URLUtil = require("app/util/browser/url");
var moment = require("moment");
moment.locale("pt-br");

var ActivitiesWrapper = React.createClass({
  componentDidMount:  function() {
    agendorAPI.sessionId = this.props.token;
    agendorAPI.jwt = this.props.jwt;
  },
  getInitialState: function() {
    var queryString = URLUtil.parseQueryStringToObject(document.location.search);

    return {
      totalActivitiesCount: 0,
      formats: this.props.formats,
      messages: this.props.messages,
      queryString: queryString,
      showActivityInput: this.shouldShowActivityInput(queryString)
    };
  },
  updateTotalActivitiesCount: function(n) {
    this.setState({
      totalActivitiesCount: n
    });
  },
  shouldShowActivityInput: function (queryString) {
    return queryString["addActivity"] == "1";
  },
  toggleActivityInput: function () {
    this.setState({
      showActivityInput: !this.state.showActivityInput
    });
  },
  render: function() {
    return(
      <div>
        <ActivitiesFilters {...this.state} toggleActivityInput={this.toggleActivityInput} />
        <ActivityInputWrapper {...this.state} {...this.props}/>
        <ActivitiesListing {...this.state} {...this.props}
           updateTotalActivitiesCount={this.updateTotalActivitiesCount} />
      </div>
    );
  }
});

var ActivityInputWrapper = React.createClass({
  render: function () {
    return (
      <div>
        {
          this.props.showActivityInput
          ? <ActivityInput {...this.props} totalActivitiesCount={this.props.totalActivitiesCount} />
          : null
        }
      </div>
    );
  }
});

module.exports = ActivitiesWrapper;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityList/activities-wrapper.jsx